import gql from 'graphql-tag'

export const SEARCH_PINCODE = gql`
query Territories($pinFilter: String!){
 Territories(where: {PinCode: {_ilike: $pinFilter}}){      
      Area
      PinCode
      DistrictName
      StateName
      CountryName
    }
  }`
